// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"341":"749acb31","379":"6d199138"}[chunkId] + ".css";
};